<main class="whitepaper-form-page">
  <div class="inner">
    <h1>Thank you for downloading</h1>
    <h2>Avoiding Technical Debt With Smart Code</h2>
    <button class="secondary no-bg" (click)="download()">Download Again</button>
    <p class="note">Check your download folder or click above to download now.</p>
    <p>Thank you for downloading Avoiding Technical Debt With Smart Code!. You're well on your way to learning how to safeguard your business from technical debt.</p>
  </div>
</main>
